var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"tab-nav"},_vm._l((_vm.tabs),function(val,key){return _c('a',{key:key,class:['tab', { active: key === _vm.active }],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('set:tab', key)}}},[_vm._v("\n    "+_vm._s(val)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }